import { FF_WEAVE_EMBED_SAVED_SUBFLOWS, FF_SUBFLOWS_SAVED_NODES } from '@/consts/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useIsFigmaEmbedMode } from '@/contexts/FigmaEmbedModeContext';

/** Embed additionally needs {@link FF_WEAVE_EMBED_SAVED_SUBFLOWS}; per-user scoping is server-side. */
export const useSavedNodesEnabled = (): boolean => {
  const { value: isSavedNodesEnabled } = useFeatureFlag(FF_SUBFLOWS_SAVED_NODES);
  const { value: isEmbedSavedSubflowsEnabled } = useFeatureFlag(FF_WEAVE_EMBED_SAVED_SUBFLOWS);
  const isFigmaEmbedMode = useIsFigmaEmbedMode();

  if (!isSavedNodesEnabled) {
    return false;
  }
  return isFigmaEmbedMode ? Boolean(isEmbedSavedSubflowsEnabled) : true;
};
